export default "__VITE_ASSET__D_UjyzMq__"